<template>
  <v-layout row wrap :data-watch="selectedItem">
      <v-flex xs12 sm9>
          <v-text-field label="Acțiune" class="input-group--focused" disabled ref="action" :value="path" :errors="errors" :error="error" :error-messages="errorMessages"></v-text-field>
      </v-flex>
      <v-flex xs12 sm3>
          <v-dialog
            :close-on-content-click="false"
            v-model="editDialog"
            :width="!isMobile ? '60%' : ''"
           :persistent="!isMobile"
           :fullscreen="isMobile"
           :hide-overlay="isMobile"
           :transition="isMobile ? 'dialog-bottom-transition':''"
          >
            <v-btn outline slot="activator">Selectează</v-btn>
            <v-card flat>
                <v-toolbar dark color="pink">
                  <v-toolbar-title>Acțiuni</v-toolbar-title>
                  <v-spacer></v-spacer>
                  <v-toolbar-items>
                    <v-btn icon @click.native="editDialog = false">
                        <v-icon>close</v-icon>
                    </v-btn>
                  </v-toolbar-items>
                </v-toolbar>
                <action-tree :data="$store.getters['actions/tree']" mode="select"></action-tree>
            </v-card>
          </v-dialog>
      </v-flex>
  </v-layout>
</template>

<script>
import ActionTree from './ActionTree';

export default {
  components: {
    ActionTree
  },

  props: ['value', 'error', 'error-messages', 'errors'],

  data() {
    return {
      editDialog: false
    };
  },

  computed: {
    isMobile() {
      return this.$store.state.isMobile;
    },

    selectedItem() {
      const value = this.$store.state.actions.selectedItem;
      if (value) {
        this.$emit('input', value.id);
        this.editDialog = false;
      }
      return value;
    },

    path() {
      if (this.value) {
        return this.$store.getters['actions/action'](this.value).path;
      } else {
        return '';
      }
    }
  },
  mounted() {}
};
</script>

<style>
.block {
  display: block !important;
}
</style>





// WEBPACK FOOTER //
// src/components/ActionSelector.vue